import { useState, useEffect } from "react";
import { DynamicDatePicker } from "../../../components/DatePicker";
import FilterMenu from "../../../components/FilterMenu";
import Loading from "../../../components/Loading";
import {
  ChartDataParams,
  FormatChartData,
} from "../../../components/recharts/functions";
import { ReMixChart } from "../../../components/recharts/ReMixCharts";
import { convertToString } from "../../../extensions/date";
import { RajasthanIsgs } from "../../../models/rajasthan";
import { getRajasthanIsgsData } from "../../../Rest_api/RestApi";
import { ExchangeColors } from "../../Dashboard/Exchange3/FormatData";
import { R_CHART_TYPES } from "../const";
import {
  FUNCTIONS,
  getBrushIndex,
  getShowBrush,
  handleKeyChange,
  handleUnitChange,
  INTERVAL,
  RAJ_UNITS,
} from "../const_raj";
import { SearchBox } from "../../../components/Search";
import { renderHourTick } from "../../../components/recharts/components";

const GROUP_BY = [
  {
    label: "From Utility",
    key: "from_utility__name",
  },
  {
    label: "IR Link",
    key: "ir_link__name",
  },
];

const KEYS = ["time_block", "date"];

export default function ISGS() {
  const [data, setData] = useState<RajasthanIsgs[]>([]);
  const [chartKeys, setChartKeys] = useState<any[]>([]);
  const [chartData, setChartData] = useState<any[]>([]);
  const [selectedStation, setSelectedStation] = useState<any[]>([]);
  const [uniqueStations, setUniqueStations] = useState<string[]>([]);
  const [selectedKey, setselectedKey] = useState(INTERVAL[0]);
  const [selectedUnit, setSelectedUnit] = useState(RAJ_UNITS[0]);
  const [uniqueBlock, setUniqueBlock] = useState<any[]>([]);
  const [selectedGroupKeys, setSelectedGroupKeys] = useState(GROUP_BY[1]);
  const [selectedChartType, setSelectedChartType] = useState(R_CHART_TYPES[2]);

  const [loading, setLoading] = useState(true);
  const [dates, setDate] = useState({
    startDate: new Date("2025-01-06"),
    endDate: new Date("2025-01-13"),
    key: "selection",
  });
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);

  const [selectedFunction, setSelectedFunction] = useState(FUNCTIONS[0]);

  useEffect(() => {
    let filteredData = data;

    if (selectedStation.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedStation.map((i) => i.label).includes(item.station)
      );
    }
    if (selectedBlock.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedBlock.map((item) => item.value).includes(item.slot)
      );
    }
    const params: ChartDataParams = {
      keys: selectedKey.secondKey
        ? [selectedKey.firstKey, selectedKey.secondKey]
        : [selectedKey.firstKey],
      groupBy: [],
      volumeKey: "value_mw",
      aggregationKeys: ["value_mwh"],
      priceKey: "",
      averageKeys: ["value_mw"],
      sortby: selectedKey.firstKey == "station" ? ["_value_mw"] : undefined,
      data: filteredData,
    };

    const chartData = FormatChartData(params);
    console.log(chartData);

    setChartData(chartData.data);
    setChartKeys(chartData.keys);
  }, [data, selectedGroupKeys, selectedKey, selectedStation, selectedBlock]);

  useEffect(() => {
    _handleFetchData();
  }, [dates]);

  async function _handleFetchData() {
    setLoading(true);
    const response = await getRajasthanIsgsData({
      startDate: convertToString(dates.startDate),
      endDate: convertToString(dates.endDate),
    });
    setUniqueStations(
      Array.from(new Set(response.map((item) => item.station)))
    );
    setUniqueBlock(Array.from(new Set(response.map((item) => item.slot))));
    setLoading(false);
    setData(response);
  }

  return (
    <div className="gas-page-container">
      {loading && <Loading />}
      <div className="side-filters-container text-nowrap">
        <FilterMenu
          title="X-Axis"
          items={INTERVAL.map((item) => item.name)}
          selectedItems={[selectedKey.name]}
          onSelect={(item, index) => {
            handleKeyChange(index, setselectedKey, setSelectedUnit);
          }}
        />

        <FilterMenu
          title="Unit"
          items={RAJ_UNITS.map((item) => item)}
          selectedItems={[selectedUnit]}
          onSelect={(item, index) => {
            handleUnitChange(item, selectedKey, setSelectedUnit);
          }}
        />

        <FilterMenu
          title="Chart Type"
          items={R_CHART_TYPES.map((item) => item.label)}
          selectedItems={[selectedChartType.label]}
          onSelect={(item, index) => {
            setSelectedChartType(R_CHART_TYPES[index]);
          }}
        />
      </div>
      <div className="gas-chart-container">
        <div className="gas-heading gap-x-10">
          <h2 className="chartHeading w-60">ISGS Volume ({selectedUnit})</h2>
          <div className="flex gap-x-2 w-full justify-end">
            <SearchBox
              options={uniqueBlock.map((item) => {
                return { value: item, label: item };
              })}
              isMany={true}
              placeholder="Search Block"
              selectedOptions={selectedBlock}
              onChange={setSelectedBlock}
            />
            <div className="min-w-80">
              <SearchBox
                options={uniqueStations.map((item) => {
                  return { value: item, label: item };
                })}
                isMany={true}
                placeholder="Search Station"
                selectedOptions={selectedStation}
                onChange={setSelectedStation}
              />
            </div>
            <DynamicDatePicker
              setDate={(date) => setDate(date[0]!)}
              defaultDates={dates}
            />
          </div>
        </div>
        <ReMixChart
          data={chartData}
          xDataKey={selectedKey.firstKey}
          xTick={
            selectedKey.secondKey !== undefined
              ? (value: any, index: any) => {
                  return renderHourTick(value, 10);
                }
              : undefined
          }
          secondXDataKey={selectedKey.secondKey}
          unit={selectedUnit}
          showBrush={getShowBrush(chartData, selectedKey)}
          brushIndex={getBrushIndex(selectedKey)}
          legends={chartKeys.map((key, index) => {
            return {
              dataKey: key + "_value_" + selectedUnit.toLowerCase(),
              // name: key,
              name: "Total Volume " + selectedUnit,
              legendColor: ExchangeColors[index % ExchangeColors.length],
              type: selectedChartType.value,
            };
          })}
        />
      </div>
    </div>
  );
}
